import React from 'react';
import {
  Button,
  Icon,
  Table,
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';

export default function UnprocessedApprovalsCount({ isLoading, isRefetching, items, onRefetch, title }) {
  return (<Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell colSpan={4} textAlign="center">{title}</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.HeaderCell>Country</Table.HeaderCell>
        <Table.HeaderCell>Total</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {isLoading && (
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
          Loading...
          </Table.Cell>
        </Table.Row>
      )}
      {!_.isEmpty(items) &&
        _.map(items, item => <Table.Row key={item.country}>
          <Table.Cell>
            {item.country}
          </Table.Cell>
          <Table.Cell>
            {_.get(item, 'count', '-')}
          </Table.Cell>
        </Table.Row>)
      }
      {
        !_.isEmpty(items) &&
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
            <Button disabled={isRefetching} loading={isRefetching} color="pink" onClick={onRefetch}>
              <Icon name="refresh" />
            Refresh data
            </Button>
          </Table.Cell>
        </Table.Row>
      }
      {_.isEmpty(items) && !isRefetching && !isLoading && (
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
            <div style={{ marginBottom: '10px' }}>There is no data</div>
            <Button disabled={isRefetching} loading={isRefetching} color="pink" onClick={onRefetch}>
              <Icon name="refresh" />
            Refresh data
            </Button>
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  </Table>);
}

UnprocessedApprovalsCount.propTypes = {
  isLoading: PropTypes.bool,
  isRefetching: PropTypes.bool,
  items: PropTypes.array,
  onRefetch: PropTypes.func,
  title: PropTypes.string,
};

UnprocessedApprovalsCount.defaultProps = {
  isLoading: false,
  isRefetching: false,
  items: [],
  onRefetch: _.noop,
  title: '',
};



/** WEBPACK FOOTER **
 ** ./src/components/unprocessed-approvals-count/index.js
 **/